'use client';

import type { CSSProperties } from 'react';
import { Image } from 'react-datocms/image';
import styles from './AvatarStack.module.css';
import type { AvatarStackProps } from './AvatarStack.types';

export function AvatarStack({
  items,
  maxVisible = 4,
  size = 59,
  border = 8,
  column = 40,
  movement = 0.35,
  transition = 0.18,
  ltr = true,
  ringed = true,
  offset = -3,
  hasHover = true
}: Readonly<AvatarStackProps>) {
  const visibleItems = items.slice(0, maxVisible);

  const cssVars = {
    '--size': size,
    '--border': border,
    '--column': column,
    '--movement': movement,
    '--transition': transition,
    '--offset': offset
  } as CSSProperties;

  return (
    <div className={styles.container} style={cssVars} data-ltr={ltr} data-ringed={ringed} data-hover={hasHover}>
      <ul className={styles.items}>
        {visibleItems.map((item) => (
          <li key={item.name}>
            <span className={styles.name}>
              {Array.from(item.name).map((char, i) => (
                <span key={`${i}-${char}`} style={{ '--i': i } as CSSProperties}>
                  {char}
                </span>
              ))}
            </span>
            <div className={styles.avatarHolder}>
              <span className={styles.avatar}>
                {item.responsiveImage ? (
                  <Image data={item.responsiveImage} layout="fill" objectFit="cover" />
                ) : (
                  // eslint-disable-next-line @next/next/no-img-element
                  <img src={item.src} alt={item.alt ?? item.name} />
                )}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
